import SlotParentValue from '@/components/tableElements/SlotParentValue.vue';
import TaggedText from '@/components/tableElements/TaggedText.vue';
export default {
  name: 'BrandParentValue',
  emits: ['toggleChildren'],
  components: {
    SlotParentValue,
    TaggedText
  },
  props: {
    value: Object,
    collapsed: Boolean,
    tagged: {
      type: Boolean,
      default: true
    },
    image_overlays: Number,
    custom: Boolean,
    noArrow: Boolean
  }
};